import {RootState} from '..';
import {createSelector} from '@reduxjs/toolkit';

const getUserDetails = createSelector(
  (state: RootState) => state.user.userDetails,
  userDetails => userDetails,
);
const getEventCreationQuestions = createSelector(
  (state: RootState) => state.user.eventCreation.newQuestions,
  questions => questions,
);

const getEventCreationVisibilityFilters = createSelector(
  (state: RootState) => state.user.eventCreation.visibilityFilters,
  visibilityFilters => visibilityFilters ?? [],
);

const getEventCreationEvaluationQuestions = createSelector(
  (state: RootState) => state.user.eventCreation.newEvaluationQuestions,
  questions => questions,
);

export const UserSelector = {
  getUserDetails,
  getEventCreationQuestions,
  getEventCreationVisibilityFilters,
  getEventCreationEvaluationQuestions,
};
